import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';

interface ProtectedRouteProps {
  children: React.ReactNode;
  requireAuth?: boolean;
  redirectTo?: string;
}

export default function ProtectedRoute({ 
  children, 
  requireAuth = true,
  redirectTo = '/login'
}: ProtectedRouteProps) {
  const { user, loading } = useAuth();
  const location = useLocation();

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-gray-50">
        <div className="flex flex-col items-center">
          <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-600 mb-4"></div>
          <p className="text-gray-600">Cargando...</p>
        </div>
      </div>
    );
  }

  // Si requireAuth es true y no hay usuario, redirigir a login
  if (requireAuth && !user) {
    return <Navigate to={redirectTo} state={{ from: location }} replace />;
  }

  // Excepción: Permitir reset-password incluso con usuario autenticado (necesario para el flujo de recovery)
  const isResetPasswordRoute = location.pathname === '/reset-password';
  
  // Si requireAuth es false (rutas de auth) y hay usuario, redirigir a home
  // EXCEPTO si estamos en reset-password (necesario para el flujo de cambio de contraseña)
  if (!requireAuth && user && !isResetPasswordRoute) {
    return <Navigate to="/" replace />;
  }

  return <>{children}</>;
} 